import { h, Fragment } from 'preact';

import SkyItBox from '../../../components/3-molecules/sky-it-box/sky-it-box';
import SelectBox from '../../../components/3-molecules/select-box/select-box';
import Modal from '../../../components/3-molecules/modal/modal';
import { getLabel } from '../../../../labels/labelling-service';
import { WPN_POPUP_STATUS } from '../../../../global-store/subjects/auto-push-notifications/get-actions';
import OverlayWrapper from '../../../components/3-molecules/overlay-wrapper/overlay-wrapper';
import { parseWPNOptionsForSelectBox } from '../../../utils/parsers';
import SkyItModalWithPanel from '../../../components/3-molecules/sky-it-modal-with-panel/sky-it-modal-with-panel';
import SkyItPanel from '../../../components/3-molecules/sky-it-panel/sky-it-panel';
import { isSportDomain } from '../../../../utils/aem-utils';

export const renderInPage = ({
  state,
  htmlProps,
  handlers,
  pageActions,
  blockType,
  elementIdInPage,
  isActiveInPage,
}) => (
  <div
    id={elementIdInPage}
    className="c-user-preferences__auto-push-notifications c-user-preferences__widget"
    data-state={isActiveInPage ? 'active' : ''}
  >
    <SkyItBox
      title={htmlProps.title}
      description={htmlProps.description}
      options={
        state.sdk?.channel?.optedIn
          ? [
              {
                text: getLabel('wpn.unsubscribe.title'),
                onClick: () => {
                  handlers.handleWPNunsubscribe(htmlProps.selectBoxes);
                  pageActions.setConfirmBottomDialog({ isShown: false });
                },
              },
            ]
          : []
      }
    >
      {htmlProps.selectBoxes.map((selectBox) => {
        const options = parseWPNOptionsForSelectBox(selectBox.options, state.selectedOptions[selectBox.boxName]);
        const selectBoxesModifiers =
          options.length === 1 ? ['single-option'] : ['1-col', '2-cols-tablet', '4-cols-desktop'];

        return (
          <SelectBox
            {...selectBox}
            options={options}
            key={selectBox.boxName}
            modifiers={selectBoxesModifiers}
            selectedOptions={state.selectedOptions[selectBox.boxName]}
            onOptionClick={(option) =>
              handlers.handleOptionInPageClick({ selectBoxName: selectBox.boxName, option, blockType })
            }
            onSwitchClick={(checked) => handlers.handleSwitchInPageClick({ selectBox, checked, blockType })}
          />
        );
      })}
    </SkyItBox>
    <OverlayWrapper showOverlay={state.popupStatus !== WPN_POPUP_STATUS.NOTHING_IS_SHOWN}>
      {state.popupStatus === WPN_POPUP_STATUS.SHOW_CONFIRM_MODAL && (
        <Modal
          onClose={() => handlers.handleConfirmModalClose(htmlProps.selectBoxes, true)}
          modifiers={['confirm']}
          title={getLabel('wpn.confirm.dialog.title')}
          description={htmlProps.confirmDialogDescriptionText}
          footerCtaList={[
            {
              modifiers: ['no-outline', 'capitalized'],
              action: () => handlers.handleConfirmModalCancel(htmlProps.selectBoxes, true),
              label: getLabel('wpn.confirm.dialog.cancel'),
            },
            {
              modifiers: ['no-outline'],
              action: () => handlers.handleConfirmModalInPageAccept(htmlProps.selectBoxes, blockType),
              label: getLabel('wpn.confirm.dialog.accept'),
              hasArrow: true,
            },
          ]}
        />
      )}
      {
        <SkyItModalWithPanel
          onCancel={() => handlers.handlePreferencesDialogClose(htmlProps.selectBoxes)}
          isActive={state.popupStatus === WPN_POPUP_STATUS.SHOW_PREFERENCES_UNSUBSCRIBE_CONFIRM}
        >
          <SkyItPanel
            title={getLabel('global.continue.title')}
            description={getLabel(
              isSportDomain()
                ? 'wpn.preferences.unsub.sport.dialog.description'
                : 'wpn.preferences.unsub.tg24.dialog.description'
            )}
            ctaPrimaryLabel={getLabel('global.confirm')}
            ctaSecondaryLabel={getLabel('wpn.preferences.unsub.dialog.cancel')}
            onCtaPrimaryClick={() => handlers.handleWPNunsubscribeConfirmInPage(htmlProps.selectBoxes)}
            onCtaSecondaryClick={() => handlers.handlePreferencesDialogClose(htmlProps.selectBoxes)}
          />
        </SkyItModalWithPanel>
      }
    </OverlayWrapper>
  </div>
);
